/**
 * ReDelivery v1
 * El delivery mas coopado
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type EnumsItemSize = 0 | 1 | 2;

export const EnumsItemSize = {
    NUMBER_0: 0 as EnumsItemSize,
    NUMBER_1: 1 as EnumsItemSize,
    NUMBER_2: 2 as EnumsItemSize
};